import { LabelSwatch } from '@/features/labels';
// By path: the slot list is not part of the labels package's public face.
import { LABEL_SLOTS } from '@/features/labels/labelSlots';
import type { LabelColor } from '@/lib/api/generated/model';

/**
 * The eight colour swatches as radios (spec 228): one markup for the inline
 * rename editor and the create dialog, so a label's colour is chosen the same
 * way wherever it is chosen.
 *
 * Each swatch still carries its slot's name for a screen reader, and for anyone
 * who cannot separate these hues: colour is what makes the choice quick, never
 * what makes it possible (spec 063 FR-011).
 */
export function LabelColorChoice({
  name,
  value,
  onChange,
}: {
  /** The radio group's name; unique per field on the page. */
  name: string;
  value: LabelColor;
  onChange: (next: LabelColor) => void;
}) {
  return (
    <fieldset className="flex flex-col gap-1.5">
      <legend className="text-foreground text-xs font-medium">Colour</legend>
      <div className="flex flex-wrap gap-1">
        {LABEL_SLOTS.map((slot) => (
          <label
            key={slot}
            className="has-focus-visible:ring-ring has-checked:ring-foreground/60 cursor-pointer rounded-md ring-offset-2 ring-offset-[var(--card)] transition-shadow has-checked:ring-2 has-focus-visible:ring-3"
          >
            <input
              type="radio"
              name={name}
              value={slot}
              checked={value === slot}
              onChange={() => {
                onChange(slot);
              }}
              className="sr-only"
            />
            <LabelSwatch color={slot} />
            <span className="sr-only">{slot.replace('slot_', 'Slot ')}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
